// Typelizer digest fee88ab3962b071f4ba3b256efd449da
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** PATCH /c/:company_id/invoice_settings */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/invoice_settings', {}, options),
    method: 'patch',
  }),
}
